export const blobUrlToBase64AsImage = async (blobUrl: string): Promise<string | null> => {
    try {
      const response = await fetch(blobUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch blob from URL. Status: ${response.status}`);
      }
      const blob = await response.blob();
      const fileType = blob.type; // Get the file type

      console.log({fileType})
  
      if (fileType.startsWith('image/')) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64Data = reader.result as string;
            resolve(base64Data)
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob); // Read the Blob as Base64
        });
      } else {  
        console.warn('The provided file is not a JPEG.');
        return null;
      }
    } catch (error) {
      console.error('Error converting blob URL to Base64:', error);
      return null;
    }
  };
  
export const fileToBase64 = (file: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (event: ProgressEvent<FileReader>) {
        const base64String = event.target?.result as string;
        const mimeType = file.type; // Get MIME type from the file object
        resolve(`${mimeType ? `data:${mimeType};base64,` : ''}${base64String.split(',')[1]}`);
    };

    reader.onerror = function (error) {
        reject(error);
    };

    reader.readAsDataURL(file);
});
};


export const generateQueryString = (data: any) => {
  return Object.keys(data)
    .map(key => {
      const value = data[key];

      // If the value is an array, join the values with commas and encode each part
      if (Array.isArray(value) && value.length) {
        const encodedValue = value
          .map(item => encodeURIComponent(item)) // Encode each item in the array
          .join(','); // Join them with commas
        return `${key.toLowerCase()}=${encodedValue}`;
      }

      // If the value is a string, number, or boolean, return it directly without encoding
      else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        return `${key.toLowerCase()}=${String(value)}`; // No encoding, just convert to string if necessary
      }

      return '';
    })
    .filter(Boolean) // Filter out any empty strings
    .join('&'); // Join all key-value pairs with "&"
};
